export const carrotThemeQ = 'CARROT_THEME_SHIM_Q';
export const jqueryQName = 'JQUERY_QUEUE';

export const INSTANTIATE = 'INSTANTIATE';
export const INSTANCE_METHOD_CALL = 'INSTANCE_METHOD_CALL';

export function shimCatch() {
  const Q = window[carrotThemeQ];
  if (!Q) {
    return;
  }
  const jqueryQ = Q[jqueryQName];
  if (!jqueryQ || jqueryQ.length < 1) {
    return;
  }

  const state = {jq: null};
  jqueryQ.forEach(function (step) {
    const ACTION = 0;
    if (step[ACTION] === INSTANTIATE) {
      const ARGUMENTS = 1;
      return state.jq = jQuery(step[ARGUMENTS]);
    }
    if (step[ACTION] === INSTANCE_METHOD_CALL) {
      const FUNCTION_NAME = 1;
      const ARGUMENTS = 2;
      return state.jq = state.jq[step[FUNCTION_NAME]](...step[ARGUMENTS]);
    }
  });
}



// WEBPACK FOOTER //
// ./assets/scripts/lib/head-catch.js